import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useState } from 'react';

function Footer() {
  const [isHovered, setIsHovered] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  
  const handleMouseMove = (e) => {
    const footer = e.currentTarget.getBoundingClientRect();
    setMousePosition({
      x: e.clientX - footer.left,
      y: e.clientY - footer.top
    });
  };

  return (
    <motion.footer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="relative overflow-hidden bg-black text-white"
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Dynamic gradient spotlight effect */}
      <div 
        className="absolute pointer-events-none transition-opacity duration-500"
        style={{
          background: `radial-gradient(circle 400px at ${mousePosition.x}px ${mousePosition.y}px, rgba(56, 189, 248, 0.15), transparent 50%)`,
          width: '100%',
          height: '100%',
          opacity: isHovered ? 1 : 0,
          top: 0,
          left: 0
        }}
      />

      {/* Glass background effect */}
      <div className="relative backdrop-blur-sm bg-gradient-to-b from-slate-900/95 to-black/95 border-t border-slate-800/50 py-12">
        <div className="container mx-auto px-6">
          {/* Main content grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12">
            {/* Company info */}
            <div>
              {/* Logo */}
              <div className="mb-6">
                <img src="/assets/images/Logo3.png" alt="Structural Solutions" className="h-32" />
              </div>
              
              <div className="space-y-4 text-sm">
                <p className="text-gray-300 leading-relaxed">
                  Creating innovative structural engineering solutions that push the boundaries of what's possible, since 2015.
                </p>
     
              </div>
            </div>
            
            {/* Quick links */}
            <div>
              <h3 className="text-sky-400 font-semibold text-sm uppercase tracking-wide mb-4">Navigation</h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="group flex items-center text-gray-300 text-sm hover:text-white transition-colors">
                    <span className="w-0 group-hover:w-5 transition-all duration-300 h-px bg-sky-400 mr-0 group-hover:mr-2"></span>
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="group flex items-center text-gray-300 text-sm hover:text-white transition-colors">
                    <span className="w-0 group-hover:w-5 transition-all duration-300 h-px bg-sky-400 mr-0 group-hover:mr-2"></span>
                    About
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="group flex items-center text-gray-300 text-sm hover:text-white transition-colors">
                    <span className="w-0 group-hover:w-5 transition-all duration-300 h-px bg-sky-400 mr-0 group-hover:mr-2"></span>
                    Services
                  </Link>
                </li>
                <li>
                  <Link to="/projects" className="group flex items-center text-gray-300 text-sm hover:text-white transition-colors">
                    <span className="w-0 group-hover:w-5 transition-all duration-300 h-px bg-sky-400 mr-0 group-hover:mr-2"></span>
                    Projects
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="group flex items-center text-gray-300 text-sm hover:text-white transition-colors">
                    <span className="w-0 group-hover:w-5 transition-all duration-300 h-px bg-sky-400 mr-0 group-hover:mr-2"></span>
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            
            {/* Services */}
            <div>
              <h3 className="text-sky-400 font-semibold text-sm uppercase tracking-wide mb-4">Services</h3>
              <ul className="space-y-2">
                <li>
                  <a href="/services" className="group flex items-center text-gray-300 text-sm hover:text-white transition-colors">
                    <span className="w-0 group-hover:w-5 transition-all duration-300 h-px bg-sky-400 mr-0 group-hover:mr-2"></span>
                    Commercial Sector: Façade Engineering
                  </a>
                </li>
                <li>
                  <a href="/services" className="group flex items-center text-gray-300 text-sm hover:text-white transition-colors">
                    <span className="w-0 group-hover:w-5 transition-all duration-300 h-px bg-sky-400 mr-0 group-hover:mr-2"></span>
                    Commercial Sector: Steel & Aluminum Structures
                  </a>
                </li>
                <li>
                  <a href="/services" className="group flex items-center text-gray-300 text-sm hover:text-white transition-colors">
                    <span className="w-0 group-hover:w-5 transition-all duration-300 h-px bg-sky-400 mr-0 group-hover:mr-2"></span>
                    Residential Sector
                  </a>
                </li>
             
              </ul>
            </div>
            
            {/* Contact info */}
            <div>
              <h3 className="text-sky-400 font-semibold text-sm uppercase tracking-wide mb-4">Contact Us</h3>
              <ul className="space-y-3">
                <li className="flex gap-3 items-start">
                  <div className="rounded-full p-1.5 bg-slate-800/80 backdrop-blur-sm">
                    <svg className="w-4 h-4 text-sky-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                  </div>
                  <span className="text-sm text-gray-300">18322 SW 135th Ave<br/> Miami, FL 33177</span>
                </li>
                <li className="flex gap-3 items-start">
                  <div className="rounded-full p-1.5 bg-slate-800/80 backdrop-blur-sm">
                    <svg className="w-4 h-4 text-sky-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                      <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                  </div>
                  <span className="text-sm text-gray-300">info@facadeconnection.com</span>
                </li>
                <li className="flex gap-3 items-start">
                  <div className="rounded-full p-1.5 bg-slate-800/80 backdrop-blur-sm">
                    <svg className="w-4 h-4 text-sky-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"></path>
                    </svg>
                  </div>
                  <span className="text-sm text-gray-300">+1 (305) 528-1054</span>
                </li>
              </ul>
            </div>
          </div>
          
          {/* Bottom section with copyright and additional links */}
       <div className="pt-6 mt-6 border-t border-slate-800/80 flex justify-center">
  <div className="text-sm text-gray-400 text-center">
    © {new Date().getFullYear()} The Facade Connection. All rights reserved.
  </div>
</div>
        </div>
      </div>
    </motion.footer>
  );
}

export default Footer;